@if(isLoadedChecklist) {
<form [formGroup]="checklistForm">
    <!-- Checklist -->
    <!-- /////////////////////////////////////////////////////// -->

    <div nxLayout="grid nopadding" class="grid_remove_padding">

        @if(data && data.length > 0) {
        <ng-container formArrayName="rows">
            @for (checklist of data; track checklist) {
            <ng-container [formGroupName]="$index">
                <div nxRow class="nx-margin-bottom-2m">
                    <div nxCol="2,2,1" class="checklist">
                       <span nxCopytext="normal">{{ $index + 1 }}</span>
                    </div>
                    <div nxCol="10,10,11" class="checklist">
                       <span nxCopytext="normal">{{ checklist.questionDesc }}</span>
                       <nx-radio-group formControlName="declareAns" [name]="'declareAns' + $index">
                          <div class="horizontal-checkboxes nx-margin-top-s">
                             <nx-radio value="1" class="padding_right_30">Yes</nx-radio>
                             <nx-radio value="2">No</nx-radio>
                          </div>
                       </nx-radio-group>
                    </div>
                 </div>
            </ng-container>
            }
        </ng-container>
        }
        

        @if (!isViewOnly) {
            @if (note) {
            <div nxRow>
                <div nxCol="12">
                    <p nxCopytext="medium" class="nx-margin-bottom-2m">
                        <i>{{ note }}</i>
                    </p>
                </div>
            </div>
            }

            <!-- @if(!checklistLov || checklistLov.length == 0) { -->
            <div nxRow>
                <div nxCol="12">
                    <nx-formfield label="Remarks">
                        <textarea formControlName="remarks" nxInput type="text" #inputToCount maxlength="100" cdkTextareaAutosize appToUpperCase></textarea>
                        <span nxFormfieldHint>
                            @if(inputToCount.value?.length === 0) {
                            <span>
                                {{ 'COMMON.CHAR_MAX_LIMIT' | translate: { fieldName: 100 } }}
                            </span>
                            }@else {
                            <span>
                                {{ 100 - (inputToCount.value.length || 0) }}
                                {{ 'COMMON.CHAR_REMAINING' | translate }}
                            </span>
                            }
                        </span>
                    </nx-formfield>
                </div>
            </div>
            <!-- } -->
        
        }@else {
            <div nxRow>
                <div nxCol="12">
                    @if(note) {
                    <p nxCopytext="medium" class="nx-margin-bottom-2m">
                        <i>{{ note }}</i>
                    </p>
                    }

                    <!-- @if(!checklistLov || checklistLov.length == 0) { -->
                    <p nxCopytext="normal" class="nx-margin-bottom-2m">
                        Remarks: {{ formatData(checklistRemarks) }}
                    </p>
                    <!-- } -->
                </div>
            </div>
        }

    </div>
</form>
}